export const QR_HOST = 'qr.rworldreuse.com';

export const buildQrCodeUrl = (code: string): string =>
  `https://${QR_HOST}/${code.replace(/^\/+/, '')}`;

export const isQrHost = (
  hostname: string = window.location.hostname,
): boolean => hostname === QR_HOST || hostname.startsWith('qr.');

export const normalizeQrCodeUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    const path = parsed.pathname.replace(/\/+$/, '') || '';
    return `${parsed.origin}${path}`;
  } catch {
    return url.replace(/\/+$/, '');
  }
};

/**
 * Temporary: codes in this inclusive range are not in the item catalog yet.
 * They all belong to one venue, whose id is REACT_APP_GOOGLE_LOCATION_ID_FOR_QR.
 * 05010504000000001 through 05010504000040000.
 */
const GOOGLE_QR_CODE_MIN = BigInt('05010504000000001');
const GOOGLE_QR_CODE_MAX = BigInt('05010504000040000');

const qrCodeValue = (qrCodeUrl: string): bigint | undefined => {
  let code = qrCodeUrl;

  try {
    code = new URL(qrCodeUrl).pathname;
  } catch {
    // Already a bare code.
  }

  code = code.replace(/^\/+|\/+$/g, '');

  if (!/^\d+$/.test(code)) {
    return undefined;
  }

  return BigInt(code);
};

export const isTemporaryGoogleQrCode = (qrCodeUrl: string): boolean => {
  const value = qrCodeValue(qrCodeUrl);

  if (value === undefined) {
    return false;
  }

  return value >= GOOGLE_QR_CODE_MIN && value <= GOOGLE_QR_CODE_MAX;
};

export const getGoogleLocationIdForQr = (): string =>
  process.env.REACT_APP_GOOGLE_LOCATION_ID_FOR_QR?.trim() || '';
